// extracted by mini-css-extract-plugin
export var cardContainer = "_po-0";
export var cardHeader = "_po-2";
export var collapsedState = "_po-3";
export var dragHandle = "_po-5";
export var dragHandleIcon = "_po-6";
export var dragging = "_po-1";
export var titleArea = "_po-4";